import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiInputAdornment-root': {
      '& > button': {
        color: theme.palette.black.main,
        padding: 0,
      },
    },
    '& .Mui-disabled': {
      '& .MuiInputAdornment-root': {
        '& > button': {
          color: theme.palette.gray.efesBorder,
          padding: 0,
        },
      },
    },
  },
}));

export default useStyles;
